import { msg } from '@lingui/core/macro';

export const ALREADY_REGISTERED_STATUS = 'AlreadyRegistered';

export const SHARED_REGISTER_EMAIL_REQUIRE = msg`Email cannot be empty.`;
export const SHARED_REGISTER_EMAIL_VALID_ERROR = msg`Please enter a valid email address.`;
export const SHARED_REGISTER_PASSWORD_REQUIRED = msg`Password cannot be empty.`;
export const SHARED_REGISTER_LOGIN_ERROR = msg`Please enter a correct email address or user ID.`;
export const SHARED_REGISTER_PASSWORD_ERROR = msg`Password incorrect. Please re-enter password`;
export const SHARED_REGISTER_USER_ALREADY_REGISTERED_ERROR = msg`You are already registered.`;
export const SHARED_REGISTER_PROVIDE_VALID_LOGIN = msg`Provide a valid login`;
export const SHARED_REGISTER_RESET_PASSWORD = msg`Reset password`;
